import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Icon from '../../components/Icon/Icon'
import TextField from '../../components/TextField/TextField'
import FooterButton from '../../components/FooterButton/FooterButton'
import Container from '../../components/Container/Container'
import objectContainsFalse from '../../helpers/objectContainsFalse'
import { NavLink } from 'react-router-dom'
import { validGroupName } from '../../helpers/validation'
import { tagGroupDetailsPage } from '../../helpers/tag/dynamicPageview'
import { updateGroupName } from '../../actions/groupDetails'
import { validateGroupDetails } from '../../actions/validation'
import { resetFlow } from '../../actions/reset'
import getPaxSummary from '../../helpers/getPaxSummary'

const stylePassengerLabel = {
  color: '#000',
}

const stylePassengerField = {
  marginLeft: '0.7rem',
}

const styleRestartLink = {
  textDecoration: 'none',
  color: '#2800a0',
  marginLeft: '0.5rem',
}

const styleGroupNameField = {
  marginLeft: '0.7rem',
  marginBottom: '1.5rem',
}

class GroupDetails extends React.Component {
  state = {
    showInputFeedback: false,
    labels: this.props.content('Group Details'),
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    tagGroupDetailsPage()
  }

  goToNextStep = () => {
    if (objectContainsFalse(this.props.validation)) {
      this.setState({ showInputFeedback: true })
    } else {
      this.props.history.push('/summary')
    }
  }

  handleChange = (keyToBeRemoved, value) => {
    this.props.validateGroupDetails({ groupName: validGroupName(value) })
    this.props.updateGroupName(value)
  }

  render() {
    const { labels, showInputFeedback } = this.state
    const { groupDetails, validation, resetFlow } = this.props
    return (
      <Container>
        <h1>
          <Icon name="groups" className="summary__icon -blue" />
          {labels['Heading']}
        </h1>
        <div style={styleGroupNameField}>
          <TextField
            type="text"
            id="groupName"
            label={labels['Group Name']}
            placeholder={labels['Group name placeholder']}
            errorMessage={labels['Group name error']}
            {...showInputFeedback && { isValid: validation.groupName }}
            onChange={this.handleChange}
            value={groupDetails.groupName}
          />
        </div>
        <div style={stylePassengerField}>
          <label style={stylePassengerLabel}>
            <strong>{labels['Number of passengers']}</strong>
          </label>
          <p>{getPaxSummary(groupDetails.party)}</p>
        </div>
        <NavLink
          onClick={() => resetFlow()}
          exact
          to="/"
          style={styleRestartLink}
        >
          <Icon name="next" />
          {labels['Restart message']}
        </NavLink>
        <FooterButton
          buttonAction={() => this.goToNextStep()}
          buttonContent={labels['Summary Button Label']}
          backButtonContent={labels['Return Button Label']}
          backButtonLink="/booker-details"
          iconName="arrow-right"
        />
      </Container>
    )
  }
}

GroupDetails.propTypes = {
  updateGroupName: PropTypes.func,
  validateGroupDetails: PropTypes.func,
  groupDetails: PropTypes.shape({
    groupName: PropTypes.string,
    party: PropTypes.array,
  }),
  validation: PropTypes.object,
  content: PropTypes.func,
  resetFlow: PropTypes.func,
  history: PropTypes.object,
}

const mapStateToProps = state => ({
  groupDetails: state.groupDetails,
  validation: state.validation.groupDetails,
})

const mapDispatchToProps = {
  updateGroupName,
  validateGroupDetails,
  resetFlow,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupDetails)
